import { h } from 'preact';
import { BaseModal, show } from 'utils/modal';
// import { joinClasses } from 'utils/utils';
// import { request, post } from 'utils/cms/data';

import IconEdit from 'components/icons/edit';

import s from 'utils/editCapacityModal.scss';

function maybeParse(value) {
	try {
		return JSON.parse(value);
	} catch (e) {
		return value;
	}
}

class EditCapacityModal extends BaseModal {
	onSubmit(e) {
		const submitter = e.submitter || document.activeElement;
		if (submitter?.value === 'cancel') {
			return;
		}
		e.preventDefault();
		const data = new FormData(e.target);
		this.base?.closest('dialog')?.close(JSON.stringify({
			// auditorium: data.get('auditorium'),
			capacity: +data.get('capacity') || 0
		}));
	}

	renderTitle() {
		return this.props.title || 'PLEASE ENSURE YOUR CHANGES HAVE BEEN APPROVED BY THE THEATER';
	}

	renderContent() {
		return [
			// <label class={s.auditorium}>
			// 	<span class={s.label}>Auditorium</span>
			// 	<div class={s.inputWrapper}>
			// 		<input name="auditorium" value={this.props.auditorium} />
			// 		<IconEdit class={s.icon} />
			// 	</div>
			// </label>,
			<label class={s.capacity}>
				<span class={s.label}>Capacity</span>
				<div class={s.inputWrapper}>
					<input type="number" name="capacity" value={this.props.capacity || 0} min="0" required />
					<IconEdit class={s.icon} />
				</div>
			</label>
		];
	}

	renderButtons() {
		const baseButtons = super.renderButtons();
		return [
			<div class={s.info}>CHANGES WILL BE APPLIED TO THIS DEVICE ONLY</div>
		].concat(baseButtons);
	}
}

export async function showEditCapacityModal(options) {
	let result = await show(
		<EditCapacityModal
			title={options?.title}
			capacity={options?.capacity}
		/>,
		options
	);
	return result === 'cancel' ? null : maybeParse(result);
}